import util from '../../common/utils';

const app = {
    state: {
        schoolName: '',
        topHeaderName: '',//页面顶部标题
        currentPath: [], // 全局面包屑
        homeWorkReportPath: process.env.VUE_APP_HOMEWORKURL,
        interactPath: 'https://datedu.oss-cn-hangzhou.aliyuncs.com/screen%2Fcloud_interact',//云端报告阿里云地址
        interactPBPath: 'https://datedu.oss-cn-hangzhou.aliyuncs.com/screen%2Fcloud_interact%2Fuserdata%2F',//云端报告pb文件阿里云地址
        freeLoginOrigin: util.getCookie("freeLoginOrigin"), // 免登录来源
        logoPathPre:'https://fs.iclass30.com/aliba/dashboard/logo/'
    },

    mutations: {
        SET_SCHOOLNAME: (state, schoolName) => {
            state.schoolName = schoolName
        },
        setCurrentPath (state, pathArr) {
            state.currentPath = pathArr;
        },
        SET_TOPHEADERNAME: (state, topHeaderName) => {
            state.topHeaderName = topHeaderName
        },
        SET_FREELOGINORIGIN: (state, origin) => {
            state.freeLoginOrigin = origin
        }
    },

    actions: {}
}

export default app
